
<mat-form-field class="example-form" appearance="outline">
  <mat-label>{{multiple ? 'Students' : 'Student'}}</mat-label>

  @if (multiple) {
    <mat-chip-grid #chipGrid aria-label="Selected students">
      @for (student of selectedStudents; track student) {
        <mat-chip-row
          (removed)="removeStudent(student)">
          {{student}}
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
      <input
        placeholder="Type to search students..."
        #studentInputMultiple
        [formControl]="studentControl"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipGrid"
        matInput>
    </mat-chip-grid>
  }

  @if (!multiple) {
    <input
      placeholder="Select a student"
      #studentInputSingle
      [formControl]="studentControl"
      [matAutocomplete]="auto"
      matInput>
  }

  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="studentSelected($event)">
    @for (student of filteredStudents | async; track student) {
      <mat-option
        [value]="student.userName">
        <span>{{student.fullName}}</span> |
        <small>Username: {{student.userName}}</small>
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
